import { OptionDataType } from "./enums";

export interface ITypedOption {
    code: string;
    dataType: OptionDataType;
    value: string;
}

export class TypedOption implements ITypedOption {
    code: string;
    dataType: OptionDataType;
    value: string;

    constructor();
    constructor(obj: ITypedOption);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.dataType = obj && obj.dataType || OptionDataType.String;
        this.value = obj && obj.value || "";
    }

    getTypedValue(): boolean | number | string {
        switch (this.dataType) {
            case OptionDataType.Boolean:
                return this.value === "1";
            case OptionDataType.Integer:
                return parseInt(this.value);
            default:
                return this.value;
        }
    }
}

export class TypedOptionSave {
    code: string;
    value: string;

    constructor();
    constructor(obj: ITypedOption);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.value = obj && obj.value || "";
    }
}
